<template>
    <div class="left-menu-container">
        <div class="blog-log">
<!--            <span>{{ appTitle }}</span>-->
<!--                        <span>趣答后台管理系统</span>-->
<!--                        <span>猜图赚后台管理系统</span>-->
<!--                        <span>猜题赚后台管理系统</span>-->
                        <span>猜词来财后台管理系统</span>

<!--            <span>测试后台管理系统</span>-->
        </div>
        <el-menu
                active-text-color="#ffd04b"
                background-color="#304156"
                class="el-menu-vertical-demo"
                default-active="/blog"
                text-color="#fff"
                unique-opened
                router
        >

            <el-menu-item index="/pages/index/index">
                <el-icon>
                    <House/>
                </el-icon>
                <span>首页</span>
            </el-menu-item>


            <el-sub-menu index="/pages/withdraw/withdraw">
                <template #title>
                    <el-icon><Money /></el-icon>
                    <span>提现审核</span>
                </template>
                <el-menu-item index="/pages/withdraw/withdrawList">
                    <el-icon>
                        <Check/>
                    </el-icon>
                    <span>正常提现</span>
                </el-menu-item>
                <el-menu-item index="/pages/withdraw/withdrawError">
                    <el-icon>
                        <Warning/>
                    </el-icon>
                    <span>异常提现</span>
                </el-menu-item>

                <el-menu-item index="/pages/withdraw/orderList">
                    <el-icon>
                        <Document/>
                    </el-icon>
                    <span>订单管理</span>
                </el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/pages/file/fileList">
                <el-icon><Upload /></el-icon>
                <span>文件上传</span>
            </el-menu-item>

            <el-sub-menu index="/pages/record/record">
                <template #title>
                    <el-icon><List /></el-icon>
                    <span>明细管理</span>
                </template>
                <el-menu-item index="/pages/record/recordList">
                    <el-icon><GoldMedal /></el-icon>
                    <span>积分明细</span>
                </el-menu-item>
                <el-menu-item index="/pages/record/ecpmRecordList">
                    <el-icon>
                        <TrendCharts/>
                    </el-icon>
                    <span>ECPM明细</span>
                </el-menu-item>
                <el-menu-item index="/pages/record/balanceRecordList">
                    <el-icon><Coin /></el-icon>
                    <span> 红包明细</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/totalRecord/totalRecordList">
                <template #title>
                    <el-icon>
                        <DataLine/>
                    </el-icon>
                    <span>记录模块</span>
                </template>
                <el-menu-item index="/pages/totalRecord/totalRecordList">
                    <el-icon>
                        <Calendar/>
                    </el-icon>
                    <span>每日统计</span>
                </el-menu-item>
<!--                <el-menu-item index="/pages/totalRecord/dashboard">-->
<!--                    <el-icon>-->
<!--                        <Setting/>-->
<!--                    </el-icon>-->
<!--                    <span>仪表盘</span>-->
<!--                </el-menu-item>-->
            </el-sub-menu>

            <el-sub-menu index="/pages/appConfig/appConfig">
                <template #title>
                    <el-icon>
                        <Tools/>
                    </el-icon>
                    <span>配置管理</span>
                </template>
                <el-menu-item index="/pages/appConfig/appConfigList">
                    <el-icon>
                        <Iphone/>
                    </el-icon>
                    <span>APP配置</span>
                </el-menu-item>
                <el-menu-item index="/pages/appConfig/adTypeConfig">
                    <el-icon>
                        <VideoPlay/>
                    </el-icon>
                    <span>广告配置</span>
                </el-menu-item>


                <el-menu-item index="/pages/appConfig/extFieldList">
                    <el-icon>
                        <Edit/>
                    </el-icon>
                    <span>APP配置字段</span>
                </el-menu-item>
                <el-menu-item index="/pages/appConfig/wxPayConfigList">
                    <el-icon>
                        <Wallet/>
                    </el-icon>
                    <span>微信支付配置</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/sign/sign">
                <template #title>
                    <el-icon>
                        <Checked/>
                    </el-icon>
                    <span>签到管理</span>
                </template>
                <el-menu-item index="/pages/sign/signList">
                    <el-icon>
                        <Notebook/>
                    </el-icon>
                    <span>签到配置</span>
                </el-menu-item>
                <el-menu-item index="/pages/sign/signRecordList">
                    <el-icon>
                        <Timer/>
                    </el-icon>
                    <span>签到记录</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/task/task">
                <template #title>
                    <el-icon>
                        <Checked/>
                    </el-icon>
                    <span>任务管理</span>
                </template>
                <el-menu-item index="/pages/task/taskList">
                    <el-icon>
                        <Notebook/>
                    </el-icon>
                    <span>任务配置</span>
                </el-menu-item>
                <el-menu-item index="/pages/task/taskRecordList">
                    <el-icon>
                        <Timer/>
                    </el-icon>
                    <span>任务记录</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/exclusive/exclusive">
                <template #title>
                    <el-icon>
                        <Lock/>
                    </el-icon>
                    <span>独享任务</span>
                </template>
                <el-menu-item index="/pages/exclusive/exclusiveMissionList">
                    <el-icon>
                        <Notebook/>
                    </el-icon>
                    <span>任务配置</span>
                </el-menu-item>
                <el-menu-item index="/pages/exclusive/exclusiveRecordList">
                    <el-icon>
                        <Timer/>
                    </el-icon>
                    <span>任务记录</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/user/user">
                <template #title>
                    <el-icon>
                        <User/>
                    </el-icon>
                    <span>用户管理</span>
                </template>

                <el-menu-item index="/pages/user/addressList">
                    <el-icon>
                        <MapLocation/>
                    </el-icon>
                    <span>区域列表</span>
                </el-menu-item>

                <el-menu-item index="/pages/user/ipList">
                    <el-icon>
                        <Monitor/>
                    </el-icon>
                    <span>IP列表</span>
                </el-menu-item>
                <el-menu-item index="/pages/user/userList">
                    <el-icon>
                        <UserFilled/>
                    </el-icon>
                    <span>用户列表</span>
                </el-menu-item>

                <el-menu-item index="/pages/user/markUserList">
                    <el-icon>
                        <Flag/>
                    </el-icon>
                    <span>标记用户</span>
                </el-menu-item>

                <el-menu-item index="/pages/user/maxEcpmMarkList">
                    <el-icon>
                        <WarningFilled/>
                    </el-icon>
                    <span>ecpm异常标记</span>
                </el-menu-item>

                <el-menu-item index="/pages/user/inviterList">
                    <el-icon>
                        <Share/>
                    </el-icon>
                    <span>邀请者列表</span>
                </el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/pages/black/black">
                <template #title>
                    <el-icon>
                        <WarningFilled/>
                    </el-icon>
                    <span>黑名单管理</span>
                </template>


                <el-menu-item index="/pages/black/blackList">
                    <el-icon>
                        <UserFilled/>
                    </el-icon>
                    <span>用户黑名单列表</span>
                </el-menu-item>

                <el-menu-item index="/pages/black/blackAreaConfig">
                    <el-icon>
                        <Location/>
                    </el-icon>
                    <span>区域阈值配置</span>
                </el-menu-item>

<!--                <el-menu-item index="/pages/black/blackAreaList">-->
<!--                    <el-icon>-->
<!--                        <UserFilled/>-->
<!--                    </el-icon>-->
<!--                    <span>区域管理</span>-->
<!--                </el-menu-item>-->

                <el-menu-item index="/pages/black/idfaBlackList">
                    <el-icon>
                        <Cellphone/>
                    </el-icon>
                    <span>设备黑名单(IDFA)</span>
                </el-menu-item>
                <el-menu-item index="/pages/black/dIDBlackList">
                    <el-icon>
                        <Phone/>
                    </el-icon>
                    <span>设备黑名单(DID)</span>
                </el-menu-item>

            </el-sub-menu>

            <el-menu-item index="/pages/white/whiteList">
                <el-icon>
                    <Medal/>
                </el-icon>
                <span>代理用户</span>
            </el-menu-item>

            <el-sub-menu index="/pages/notice/notice">
                <template #title>
                    <el-icon>
                        <Bell/>
                    </el-icon>
                    <span>公告管理</span>
                </template>
                <el-menu-item index="/pages/notice/noticeList">
                    <el-icon>
                        <DocumentCopy/>
                    </el-icon>
                    <span>公告列表</span>
                </el-menu-item>
                <el-menu-item index="/pages/notice/noticeAdd">
                    <el-icon>
                        <CirclePlus/>
                    </el-icon>
                    <span>发布公告</span>
                </el-menu-item>
            </el-sub-menu>

            <!--            <el-sub-menu index="/pages/test/test">-->
            <!--                <template #title>-->
            <!--                    <el-icon>-->
            <!--                        <Document/>-->
            <!--                    </el-icon>-->
            <!--                <span>测试使用(忽略)</span>-->
            <!--                </template>-->
            <!--                <el-menu-item index="/pages/test/testList">-->
            <!--                    <el-icon>-->
            <!--                        <Setting/>-->
            <!--                    </el-icon>-->
            <!--                    <span>加密</span>-->
            <!--                </el-menu-item>-->
            <!--            </el-sub-menu>-->
        </el-menu>
    </div>
</template>

<script>
    export default {
        name: "Menu",
        computed: {
            appTitle() {
                return process.env.VUE_APP_TITLE || '后台管理系统';
            }
        }}
</script>

<style lang="less" scoped>
    .left-menu-container {
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: #304156;
    }

    .el-menu {
        width: 200px;
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        border-right: none;
    }

    /* 自定义滚动条样式 */
    .el-menu::-webkit-scrollbar {
        width: 6px;
    }

    .el-menu::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 3px;
    }

    .el-menu::-webkit-scrollbar-thumb:hover {
        background-color: rgba(255, 255, 255, 0.5);
    }

    .el-menu::-webkit-scrollbar-track {
        background-color: transparent;
    }

    .blog-log {
        width: 100%;
        height: 60px;
        font-weight: bolder;
        font-size: 20px;
        color: white;
        text-align: center;
        line-height: 60px;
        border-bottom: white solid 1px;
        background-color: #304156;
        flex-shrink: 0;
        /*background-color: yellow;*/
    }

    /* iPad 适配样式 */
    @media (max-width: 1024px) {
        .el-menu {
            width: 180px;
        }

        .blog-log {
            font-size: 16px;
            height: 50px;
            line-height: 50px;
        }
    }

</style>
